module.exports = __webpack_public_path__ + "static/media/promotional-graphic.67b672fa.png";